/* ============================================================
   FREEPET Downloads - page-scoped script
   Target: assets/freepet-download.js
   Stage-B v2.0: ZERO dollar-sign characters (PB-30)
   All selectors use FP.q / FP.qa (alias for querySelector)
   or document.querySelector directly. No FP.$ / FP.$$ anywhere.
   ============================================================ */

(function(){
'use strict';

var FP = window.FP = window.FP || {};

/* ------------------------------------------------------------
   Selector helpers (NO dollar signs - PB-30 safety)
   ------------------------------------------------------------ */
FP.q = FP.q || function(s, r){ return (r || document).querySelector(s); };
FP.qa = FP.qa || function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
FP.toast = FP.toast || function(msg){
  var t = FP.q('[data-lang-toast]');
  if(!t) return;
  t.textContent = msg;
  t.hidden = false;
  void t.offsetHeight;
  t.classList.add('is-visible');
  clearTimeout(t._toastTimer);
  t._toastTimer = setTimeout(function(){
    t.classList.remove('is-visible');
    setTimeout(function(){ t.hidden = true; }, 320);
  }, 2400);
};

/* ============================================================
   1 - Nav active state (Downloads entry)
   ============================================================ */
function initNavActive(){
  var page = document.documentElement.getAttribute('data-page');
  if(!page) return;
  var MAP = { 'downloads': '/pages/downloads' };
  var targetHref = MAP[page];
  if(!targetHref) return;
  requestAnimationFrame(function(){
    var links = document.querySelectorAll('.fp-nav-link, .fp-mmenu-link');
    for(var i = 0; i < links.length; i++){
      if(links[i].getAttribute('href') === targetHref){
        links[i].classList.add('is-active');
        links[i].setAttribute('aria-current', 'page');
      }
    }
  });
}

/* ============================================================
   2 - Video Hero (21:9 click lazy-load)
   ============================================================ */
function initDlVhero(){
  var root = document.querySelector('[data-section="download-vhero"]');
  if(!root) return;
  var card = root.querySelector('.fp-dl-vhero-card');
  var video = root.querySelector('.fp-dl-vhero-el');
  var btn = root.querySelector('.fp-dl-vhero-btn');
  if(!card || !video || !btn) return;

  btn.addEventListener('click', function(){
    var src = video.getAttribute('data-src');
    if(!src){
      var label = btn.querySelector('span');
      if(label && !btn.dataset.busy){
        btn.dataset.busy = '1';
        var original = label.textContent;
        label.textContent = 'Coming soon';
        setTimeout(function(){ label.textContent = original; delete btn.dataset.busy; }, 1800);
      }
      return;
    }
    if(!video.getAttribute('src')){ video.setAttribute('src', src); video.load(); }
    card.classList.add('is-playing');
    video.muted = false;
    var p = video.play(); if(p && p.catch) p.catch(function(){});
  });

  video.addEventListener('ended', function(){ card.classList.remove('is-playing'); video.currentTime = 0; });
  video.addEventListener('error', function(){ video.classList.add('is-error'); card.classList.remove('is-playing'); }, { passive:true });

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){
      if(!en[0].isIntersecting && !video.paused) video.pause();
    }, { threshold:0.15 });
    io.observe(root);
  }
  document.addEventListener('visibilitychange', function(){
    if(document.hidden && !video.paused) video.pause();
  });
}

/* ============================================================
   3 - Download button demo intercept
   ============================================================ */
function initDownloadDemo(){
  var root = document.querySelector('[data-section="download-groups"]');
  if(!root) return;
  root.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.fp-dl-btn') : null;
    if(!btn) return;
    var href = btn.getAttribute('href');
    if(href === '#'){
      e.preventDefault();
      var label = btn.getAttribute('data-track-label') || 'file';
      var human = label.replace(/^dl_/, '').replace(/_/g, ' ');
      FP.toast('Demo: would download "' + human + '" - connect to real file on Shopify.');
    }
  });
}

/* ============================================================
   4 - Video Guides play button demo feedback
   ============================================================ */
function initVideoGuideDemo(){
  var root = document.querySelector('[data-section="download-video"]');
  if(!root) return;
  root.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.fp-dl-video-play') : null;
    if(!btn) return;
    var realUrl = btn.getAttribute('data-video-url');
    if(!realUrl){
      var card = btn.closest('.fp-dl-video-card');
      if(card) realUrl = card.getAttribute('data-video-url');
    }
    if(realUrl){ return; }
    e.preventDefault();
    e.stopPropagation();
    var label = btn.getAttribute('data-track-label') || 'video';
    var human = label.replace(/^dl_video_/, '').replace(/_/g, ' ');
    FP.toast('Demo: would open video "' + human + '" - connect to YouTube / MP4 on Shopify.');
  });
}

/* ============================================================
   5 - Download FAQ accordion (event delegation, zero FP deps)
   ============================================================ */
function initDlFaq(){
  var root = document.querySelector('[data-section="download-faq"]');
  if(!root) return;
  root.addEventListener('click', function(e){
    var q = e.target.closest ? e.target.closest('.fp-dl-faq-q') : null;
    if(!q) return;
    var item = q.closest('.fp-dl-faq-item');
    if(!item) return;
    var wasOpen = item.classList.contains('is-open');
    var allItems = root.querySelectorAll('.fp-dl-faq-item');
    for(var i = 0; i < allItems.length; i++){
      allItems[i].classList.remove('is-open');
      var btn = allItems[i].querySelector('.fp-dl-faq-q');
      if(btn) btn.setAttribute('aria-expanded', 'false');
    }
    if(!wasOpen){
      item.classList.add('is-open');
      q.setAttribute('aria-expanded', 'true');
    }
  });
}

/* ============================================================
   6 - Newsletter validation gate
   ============================================================ */
var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function initDlNewsletter(){
  var r = document.querySelector('[data-section="download-newsletter"]');
  if(!r) return;
  var form = r.querySelector('form');
  if(!form) return;
  var msg = r.querySelector('.fp-form-msg');
  var input = form.querySelector('input[type="email"]');
  form.addEventListener('submit', function(e){
    var v = input ? input.value.trim() : '';
    if(!EMAIL_RE.test(v)){
      e.preventDefault();
      if(msg){
        msg.textContent = 'Please enter a valid email address.';
        msg.className = 'fp-form-msg fp-form-msg-error';
      }
      if(input) input.focus();
    }
  });
}

/* ============================================================
   Boot
   ============================================================ */
function boot(){
  [initNavActive, initDlVhero, initDownloadDemo, initVideoGuideDemo, initDlFaq, initDlNewsletter].forEach(function(fn){
    try{ fn(); }catch(e){ if(window.console) console.warn('[FP DL] init error:', fn.name, e); }
  });
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

})();